import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyPricePlan = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyPricePlan);
};
